import { createNgReactBridgeConstant } from '../../react-bridge'

const ATTACK_MONITOR_FILTER_GROUPS = {
  ATTACKERS: 'ATTACKERS',
  RULES: 'RULES',
  APPLICATIONS: 'APPLICATIONS'
}

createNgReactBridgeConstant(
  'ATTACK_MONITOR_FILTER_GROUPS',
  ATTACK_MONITOR_FILTER_GROUPS
)
